import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { ProductsContext } from "./ProductsContext";
import { useHistory } from "react-router-dom";
import { GET_FILTERED_PRODUCTS } from "../../queries/productsQuery";

export const ProductsContextProvider = (props) => {
  const history = useHistory();
  const [activeCategoryId, setActiveCategoryId] = useState(0);
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [brandPath, setBrandPath] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState();

  const { data: productsData, fetchMore } = useQuery(GET_FILTERED_PRODUCTS, {
    variables: {
      limit: 20,
      categoryId: selectedCategoryId || undefined,
      category: selectedSubCategoryId || undefined,
      brandSlug: brandPath || undefined,
    },
  });

  const changeActiveCategory = () => {
    setActiveCategoryId(9999);
  };

  const loadMore = () => {
    const pageInfo = productsData?.products?.pageInfo;
    if (!pageInfo?.hasNextPage) return;

    fetchMore({
      variables: {
        limit: 20,
        after: pageInfo.endCursor,
        categoryId: selectedCategoryId || undefined,
        category: selectedSubCategoryId || undefined,
        brandSlug: brandPath || undefined,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          products: {
            ...fetchMoreResult.products,
            nodes: [
              ...prev.products.nodes,
              ...fetchMoreResult.products.nodes,
            ],
          },
        };
      },
    });
  };

  const filterAllProducts = () => {
    setSelectedCategoryId(0);
    setActiveCategoryId(0);
    setBrandPath(undefined);
    setSelectedSubCategoryId("");
    history.push("/kategoria/");
  };

  const filterProductsWithCategory = (id, categoryName) => {
    setActiveCategoryId(id);
    setSelectedSubCategoryId("");
    history.push(`/kategoria/${categoryName}`);
    setSelectedCategoryId(id);
  };

  const handleCategoryChange = (id, categoryName) => {
    setActiveCategoryId(id);
    setSelectedCategoryName(categoryName);
  };

  const handleSubCategoryChange = (slug) => {
    setSelectedCategoryId(0);
    setActiveCategoryId("");
    setSelectedSubCategoryId(slug);
    history.push(`/kategoria/${slug}`);
  };

  const changeSubCategoryPath = (value) => {
    setBrandPath(undefined);
    setSelectedSubCategoryId(value);
  };

  const changeBrandPath = (value) => {
    setSelectedSubCategoryId(undefined);
    setBrandPath(value);
  };

  const context = {
    selectedCategoryId,
    handleCategoryChange,
    handleSubCategoryChange,
    selectedCategoryName,
    selectedSubCategoryId,
    loadMore,
    productsData,
    filterAllProducts,
    activeCategoryId,
    changeSubCategoryPath,
    changeBrandPath,
    filterProductsWithCategory,
    changeActiveCategory,
  };

  return (
    <ProductsContext.Provider value={context}>
      {props.children}
    </ProductsContext.Provider>
  );
};
